export default "__VITE_ASSET__C27viqV7__"